import React from "react";
import { useTranslation } from "react-i18next";
import { FaCheck } from "react-icons/fa";
import { ReactComponent as Icon } from "../../icons/work-experience/trophy.svg";
import "./workexperience.css";

export default function Achievements({ id }) {
  const { t } = useTranslation();
  const responsabilities = t(`experience.${id}.achievements`, {
    returnObjects: true,
  });

  return (
    <div className="content-container">
      <h2 className="we-card-title">{t("experience.achievements")}</h2>
      <div className="bullet-list">
        {responsabilities.map(({ text }) => (
          <span key={text}>
            <FaCheck />
            <p>{text}</p>
          </span>
        ))}
      </div>
      <div className="we-bg-icon">
        <Icon />
      </div>
    </div>
  );
}
